/**
 * One screen's claim on the way out.
 *
 * The costing sheet is twenty-odd fields of typing with no autosave, and it
 * refuses to save a costing that cannot yet be priced -- so a stray click on
 * the sidebar used to end the work silently, with nothing written down. The
 * browser's own `beforeunload` covers closing the tab and reloading, but this
 * app navigates by swapping React state, which `beforeunload` never sees.
 *
 * So the screen that has something to lose registers a question here, and the
 * one place that navigates (`go` in App.tsx) asks it first. A module-level
 * slot rather than context: one screen at a time can be mid-edit, App should
 * not have to know what a costing is, and a screen that forgets to clear its
 * guard on unmount would be a bug in that screen, not a shape to design for.
 */

let ask: (() => boolean) | null = null;

/** Register a question, or pass null on unmount to clear it. */
export function guardUnsaved(fn: (() => boolean) | null): void {
  ask = fn;
}

/** True when nothing objects, or the person said to go anyway. */
export function mayLeave(): boolean {
  return ask ? ask() : true;
}
